import { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

function ValidateIcon(props: SvgIconProps) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11ZM11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM16.5018 8.70675C16.8921 8.31603 16.8918 7.68287 16.5011 7.29254C16.1104 6.90221 15.4772 6.90253 15.0869 7.29325L9.79359 12.5954L7.50105 10.3028C7.11053 9.91229 6.47736 9.91229 6.08684 10.3028C5.69631 10.6933 5.69631 11.3265 6.08684 11.717L9.08684 14.717C9.27444 14.9046 9.52889 15.01 9.7942 15.0099C10.0595 15.0098 10.3139 14.9044 10.5014 14.7167L16.5018 8.70675Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoValidateIcon = React.memo(ValidateIcon);
export default MemoValidateIcon;
